import { UrlConstants } from "../url.constants";
export class ApiSearchOptionConstants {
    static URL = UrlConstants.API_V2 + "ModuleSearch";
    static FUNCTION_GET_FIELDLIST_FOR_SEARCH_OPTIONS = "GetFieldListForSearchOption";
    static FUNCTION_SET_SEARCH_OPTION = "SetSearchOption";
    static FUNCTION_DELETE_SEARCH_OPTION_FIELDLIST = "DeleteSearchOptionFieldList";
}
